// extracted by mini-css-extract-plugin
export default {"root":"dAHnbO","itemClickWrapper":"io5Buh","imageZoomBtn":"aG9Qlp","sizer":"J27pnx","imageWrapper":"iAFMln","imageBorder":"dKkboU","image":"xDfTVg","overlay":"tlBPGf"};